// MASAR UI translations — English (source), العربية, Français, Türkçe

export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "ar", label: "ع", name: "العربية" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "tr", label: "TR", name: "Türkçe" },
];

// Arabic city names, aligned with REGIONS_META order in Coverage.js
export const AR_CITIES = [
  ["القاهرة", "الإسكندرية", "الجيزة", "العين السخنة", "الغردقة", "الجونة", "شرم الشيخ"],
  ["الدار البيضاء", "مراكش", "الرباط", "طنجة", "أكادير"],
  ["الجزائر", "وهران", "قسنطينة", "عنابة"],
  ["تونس", "صفاقس", "سوسة", "جربة"],
  ["طرابلس", "بنغازي", "مصراتة"],
  ["عمّان", "العقبة", "البتراء", "إربد"],
  ["بيروت", "جبيل", "طرابلس", "زحلة"],
  ["إسطنبول", "أنقرة", "إزمير", "أنطاليا", "كابادوكيا", "بودروم"],
  ["الرياض", "جدة", "الدمام", "الخبر", "مكة", "المدينة", "العلا"],
  ["دبي", "أبوظبي", "الشارقة", "العين", "رأس الخيمة", "الفجيرة"],
  ["مدينة الكويت", "حولي", "الأحمدي", "الجهراء"],
  ["الدوحة", "الريان", "الوكرة", "الخور"],
  ["المنامة", "الرفاع", "المحرق"],
  ["مسقط", "صلالة", "نزوى", "صحار"],
];

const REGION_NAMES = {
  en: ["Egypt", "Morocco", "Algeria", "Tunisia", "Libya", "Jordan", "Lebanon", "Turkey", "Saudi Arabia", "United Arab Emirates", "Kuwait", "Qatar", "Bahrain", "Oman"],
  ar: ["مصر", "المغرب", "الجزائر", "تونس", "ليبيا", "الأردن", "لبنان", "تركيا", "السعودية", "الإمارات", "الكويت", "قطر", "البحرين", "عُمان"],
  fr: ["Égypte", "Maroc", "Algérie", "Tunisie", "Libye", "Jordanie", "Liban", "Turquie", "Arabie Saoudite", "Émirats Arabes Unis", "Koweït", "Qatar", "Bahreïn", "Oman"],
  tr: ["Mısır", "Fas", "Cezayir", "Tunus", "Libya", "Ürdün", "Lübnan", "Türkiye", "Suudi Arabistan", "Birleşik Arap Emirlikleri", "Kuveyt", "Katar", "Bahreyn", "Umman"],
};

export const translations = {
  en: {
    nav: {
      howItWorks: "How it works",
      services: "Services",
      coverage: "Coverage",
      faq: "FAQ",
      support: "Support",
      privacy: "Privacy",
      getApp: "Get the app",
      tag: "Motorcycle App",
    },
    announce: {
      prefix: "Now expanding: ",
      text: "MASAR rolls across North Africa, Jordan, Lebanon & Turkey — 14 countries live.",
      dismiss: "Dismiss announcement",
    },
    territory: {
      chapter: "The Territory",
      h1a: "From the Atlas dunes",
      h1to: "to",
      h1b: "Cappadocia,",
      h1c: "Petra,",
      h1d: "and the Gulf coast.",
      h1e: "— moving through Egypt.",
      para: "Fourteen countries. Sixty cities. One motorcycle app that reads the way riders roll across the region — the long Saharan highways, the Anatolian passes, the Levantine corniches, and every rally in between.",
    },
    stores: {
      appstoreCaption: "Download on the",
      playCaption: "Get it on",
    },
    marquee: {
      phrases: [
        "A Motorcycle App for MENA & Turkey",
        "14 Countries · 60+ Cities",
        "Track. Party rides. Shops. Community. SOS.",
      ],
    },
    manifesto: {
      chapter: "Manifesto",
      titleA: "Three moves between",
      titleB: "you",
      titleC: "and the open road.",
      steps: [
        {
          t: "Download & make yourself known.",
          b: "Install MASAR. Set your marque, discipline, home region. Thirty seconds.",
        },
        {
          t: "Track solo. Or roll with the crew.",
          b: "Every kilometer logged with precision — or drop into a party ride at any checkpoint.",
        },
        {
          t: "Belong somewhere.",
          b: "Chat, discover vetted shops, and know a single SOS tap has every rider around you on your side.",
        },
      ],
    },
    hero: {
      meta: "Est. 2025 · Cairo · Dubai · Istanbul",
      h1a: "The road",
      h1b: "is yours.",
      h1c: "MASAR rides",
      h1d: "with you.",
      para: "A motorcycle app for riders in MENA and Turkey. Track every kilometer, roll into party rides, discover vetted shops, and hit SOS one tap away.",
      ctaPrimary: "Download on the App Store",
      ctaSecondary: "Read the manifesto",
      statsCountries: "Countries",
      statsCities: "Cities",
      statsSos: "SOS",
      liveChip: "Live · Cairo → Ain Sokhna",
      rideMeta: "Ride 2417 · MSR",
      sosReady: "SOS ready",
    },
    services: {
      chapter: "Capabilities",
      titleA: "Five things. One app.",
      titleB: "Zero switching.",
      lede: "MASAR is the only platform built around the full spectrum of the riding life — community, navigation, commerce, and safety.",
      items: [
        {
          title: "Track your rides",
          desc: "Log every kilometer with precision. Record route, distance, duration, speed — replay each ride on a detailed map.",
          tag: "01 · Rides",
        },
        {
          title: "Party rides & events",
          desc: "Discover organized rides nearby. Join from any checkpoint along the route. Create your own with waypoints.",
          tag: "02 · Community",
        },
        {
          title: "Rider shops",
          desc: "Vetted gear shops, service centers, customization garages — tagged to your location with ratings and directions.",
          tag: "03 · Commerce",
        },
        {
          title: "In-app chat",
          desc: "Add friends, follow riders, grow your network. Group conversations, ride plans, and gear talk — all in one place.",
          tag: "04 · Connect",
        },
        {
          title: "SOS · one tap",
          desc: "Instantly alert every nearby rider with your location, show closest hospitals, and share a live link for help.",
          tag: "05 · Safety",
        },
      ],
      sosPills: [
        "Alerts nearby riders instantly",
        "Live map of closest hospitals",
        "Live location share link",
        "One-tap coordination call",
      ],
    },
    coverage: {
      chapter: "Coverage",
      titleA: "MENA &",
      titleB: "Turkey.",
      para: "MASAR is now live across 14 countries — from the Atlas Mountains to the Bosphorus, the Gulf coast to Wadi Rum. Fourteen countries, one ride hub.",
      cap1: "Egypt · Desert",
      cap2: "Gulf · Coast",
      region: "Region",
      regionValue: "MENA · Turkey · masar.ltd",
      bitCountries: "Countries",
      bitCities: "Cities",
      bitSos: "SOS",
      tags: { hq: "HQ", new: "New", live: "Live" },
      regions: REGION_NAMES.en,
    },
    features: {
      chapter: "Why MASAR",
      titleA: "Every road tells",
      titleB: "a story. We keep it.",
      lede: "Whether you're carving mountain passes solo or leading a hundred-bike convoy, MASAR gives you the tools riders actually want.",
      tag: "Feature",
      cards: [
        {
          title: "Precision ride telemetry",
          body: "Route, distance, duration, speed — logged automatically. Replay every ride on a detailed map and build a personal riding history you can share.",
        },
        {
          title: "Rallies & track days",
          body: "Browse rallies, desert runs, and organized events across the region.",
        },
        {
          title: "Waypoint planning",
          body: "Plot your route, drop checkpoints, and invite your network to roll with you.",
        },
        {
          title: "Every marque, every discipline",
          body: "Classics, baggers, muscle bikes, tourers, sport and café racers — MASAR is tuned for the way riders roll across MENA and Turkey, from the corniche to the open desert and everywhere between.",
        },
        {
          title: "Verified rider profiles",
          body: "Follow riders, add friends across marques, and see who's rolling near you.",
        },
        {
          title: "Private by default",
          body: "Your rides and location stay yours. Share only what — and with whom — you choose.",
        },
      ],
    },
    faq: {
      chapter: "FAQ",
      titleA: "Questions,",
      titleB: "answered fast.",
      lede: "Everything you need to know before your first ride with MASAR. Something missing? Reach out at",
      items: [
        {
          q: "Who is MASAR built for?",
          a: "Motorcycle riders across MENA and Turkey — from solo weekend riders to full convoy organizers. Any marque, any discipline: cruiser, sport, adventure, tourer, or café racer.",
        },
        {
          q: "What can I do inside the MASAR app?",
          a: "Five things: track your rides with precision GPS logging, join or create party rides and group events, discover vetted rider shops, chat with your community, and trigger a one-tap SOS that alerts every nearby rider and shows the closest hospitals.",
        },
        {
          q: "How exactly does the SOS feature work?",
          a: "One tap activates MASAR SOS. The app instantly alerts every nearby rider on the platform with your exact location and a navigation prompt to reach you, displays the closest hospitals and trauma centers on a live map ranked by distance, shares a live location link so responders can navigate to you, and enables one-tap calling for real-time coordination.",
        },
        {
          q: "Can I join a group ride that has already started?",
          a: "Yes. MASAR lets you join a party ride from any checkpoint along the route — no need to be at the start. Browse rides happening near you or across the region and jump in wherever it makes sense.",
        },
        {
          q: "Which countries and cities are supported?",
          a: "MASAR is live across 14 countries: Egypt, Morocco, Algeria, Tunisia, Libya, Jordan, Lebanon, Turkey, Saudi Arabia, UAE, Kuwait, Qatar, Bahrain, and Oman — 60+ cities. See the Coverage section above for the full city list.",
        },
        {
          q: "Are the shops on MASAR verified?",
          a: "Yes. All rider shops — gear, service centers, customization garages, and parts suppliers — are vetted before being listed, with ratings, inventory highlights, and one-tap directions.",
        },
        {
          q: "How do I list my shop on MASAR?",
          a: "Send us an email at emailsupport@masar.ltd with the subject line ‘Shop listing’ and we'll share the verification process and requirements.",
        },
        {
          q: "How can I contact MASAR support?",
          a: "Reach us any time at emailsupport@masar.ltd or use the contact form below. We reply within one business day.",
        },
      ],
    },
    support: {
      chapter: "Support",
      titleA: "Talk to a",
      titleB: "human.",
      lede: "Rider support, shop listings, partnerships, or press — write to us. We reply within one business day.",
      emailLabel: "Email",
      phoneLabel: "Phone (in-app)",
      phoneValue: "Request from the MASAR app",
      regionLabel: "Region",
      regionValue: "MENA · Turkey · 14 countries",
      domainLabel: "Domain",
      nameLabel: "Full name",
      emailFieldLabel: "Email",
      phoneFieldLabel: "Phone (optional)",
      subjectLabel: "Subject (optional)",
      messageLabel: "Message",
      namePh: "Your full name",
      emailPh: "you@example.com",
      phonePh: "+20 100 000 0000",
      subjectPh: "How can we help?",
      messagePh: "Tell us what you need…",
      consent: "By submitting, you agree to be contacted at the email provided.",
      send: "Send message",
      sending: "Sending…",
      success: "Message sent. We'll reply within one business day.",
      errRequired: "Please fill in name, email and message.",
      errGeneric: "Something went wrong. Please try again.",
    },
    privacySec: {
      chapter: "Privacy Policy",
      titleA: "Your data,",
      titleB: "your terms.",
      open: "Open standalone page",
      lastUpdated: "Last updated: December 2025",
    },
    footer: {
      blurb: "The motorcycle app for MENA & Turkey. Track rides, join party rides, discover shops, chat with your crew — and hit SOS when it matters most. 14 countries live.",
      navigate: "Navigate",
      contact: "Contact",
      serving: "Serving MENA & Turkey",
      hours: "Support hours: 24 / 7",
      appstoreTag: "App Store · live",
      playTag: "Google Play · live",
      rights: "© {year} MASAR · Motorcycle App. All rights reserved.",
      privacyLink: "Privacy",
      termsLink: "Terms",
    },
    legal: {
      back: "Back to site",
      legal: "Legal",
      lastUpdated: "Last updated:",
      questions: "Questions? Email us at",
      home: "Home",
      privacyTitle: "Privacy Policy",
      termsTitle: "Terms of Service",
      updated: "December 2025",
    },
  },

  ar: {
    nav: {
      howItWorks: "كيف يعمل",
      services: "الخدمات",
      coverage: "التغطية",
      faq: "الأسئلة الشائعة",
      support: "الدعم",
      privacy: "الخصوصية",
      getApp: "حمّل التطبيق",
      tag: "تطبيق دراجات نارية",
    },
    announce: {
      prefix: "نتوسع الآن: ",
      text: "مسار ينطلق عبر شمال إفريقيا والأردن ولبنان وتركيا — 14 دولة متاحة الآن.",
      dismiss: "إغلاق الإعلان",
    },
    territory: {
      chapter: "النطاق",
      h1a: "من كثبان الأطلس",
      h1to: "إلى",
      h1b: "كابادوكيا،",
      h1c: "البتراء،",
      h1d: "وساحل الخليج.",
      h1e: "— مرورًا بمصر.",
      para: "أربع عشرة دولة. ستون مدينة. تطبيق واحد للدراجات النارية يفهم طريقة تنقّل الدراجين في المنطقة — طرق الصحراء الكبرى الطويلة، وممرات الأناضول، وكورنيشات بلاد الشام، وكل رالي بينها.",
    },
    stores: {
      appstoreCaption: "حمّله من",
      playCaption: "احصل عليه على",
    },
    marquee: {
      phrases: [
        "تطبيق دراجات نارية للشرق الأوسط وشمال إفريقيا وتركيا",
        "14 دولة · أكثر من 60 مدينة",
        "تتبّع. رحلات جماعية. متاجر. مجتمع. استغاثة.",
      ],
    },
    manifesto: {
      chapter: "البيان",
      titleA: "ثلاث خطوات تفصلك عن",
      titleB: "الطريق",
      titleC: "المفتوح.",
      steps: [
        {
          t: "حمّل التطبيق وعرّف بنفسك.",
          b: "ثبّت مسار. حدّد ماركة دراجتك ونوع قيادتك ومنطقتك. ثلاثون ثانية.",
        },
        {
          t: "تتبّع وحدك. أو انطلق مع المجموعة.",
          b: "كل كيلومتر مسجّل بدقة — أو انضم إلى رحلة جماعية من أي نقطة تفتيش.",
        },
        {
          t: "انتَمِ إلى مكان ما.",
          b: "دردش، واكتشف متاجر موثوقة، واعلم أن ضغطة استغاثة واحدة تجعل كل دراج حولك إلى جانبك.",
        },
      ],
    },
    hero: {
      meta: "تأسس 2025 · القاهرة · دبي · إسطنبول",
      h1a: "الطريق",
      h1b: "أمامك.",
      h1c: "مسار يرافقك",
      h1d: "طوال الدرب.",
      para: "تطبيق دراجات نارية للدراجين في الشرق الأوسط وشمال إفريقيا وتركيا. تتبّع كل كيلومتر، وانضم إلى الرحلات الجماعية، واكتشف متاجر موثوقة، واضغط زر الاستغاثة على بُعد نقرة واحدة.",
      ctaPrimary: "حمّل من App Store",
      ctaSecondary: "اقرأ البيان",
      statsCountries: "دولة",
      statsCities: "مدينة",
      statsSos: "استغاثة",
      liveChip: "مباشر · القاهرة - العين السخنة",
      rideMeta: "رحلة 2417 · مسار",
      sosReady: "الاستغاثة جاهزة",
    },
    services: {
      chapter: "القدرات",
      titleA: "خمس مزايا. تطبيق واحد.",
      titleB: "دون تنقّل بين التطبيقات.",
      lede: "مسار هو المنصة الوحيدة المبنية حول حياة الدراج بأكملها — المجتمع والملاحة والتجارة والسلامة.",
      items: [
        {
          title: "تتبّع رحلاتك",
          desc: "سجّل كل كيلومتر بدقة. سجّل المسار والمسافة والمدة والسرعة — وأعد تشغيل كل رحلة على خريطة تفصيلية.",
          tag: "01 · رحلات",
        },
        {
          title: "رحلات جماعية وفعاليات",
          desc: "اكتشف رحلات منظمة قريبة منك. انضم من أي نقطة على الطريق. أنشئ رحلتك الخاصة بنقاط التوقف.",
          tag: "02 · مجتمع",
        },
        {
          title: "متاجر الدراجين",
          desc: "متاجر معدات موثوقة ومراكز صيانة وورش تعديل — مرتبطة بموقعك مع التقييمات والاتجاهات.",
          tag: "03 · تجارة",
        },
        {
          title: "دردشة داخل التطبيق",
          desc: "أضف أصدقاء، وتابع دراجين، ووسّع شبكتك. محادثات جماعية وخطط رحلات وأحاديث معدات — كلها في مكان واحد.",
          tag: "04 · تواصل",
        },
        {
          title: "استغاثة · ضغطة واحدة",
          desc: "نبّه فورًا كل دراج قريب مع موقعك، واعرض أقرب المستشفيات، وشارك رابط موقع مباشر لطلب المساعدة.",
          tag: "05 · سلامة",
        },
      ],
      sosPills: [
        "تنبيه فوري للدراجين القريبين",
        "خريطة مباشرة لأقرب المستشفيات",
        "رابط مشاركة الموقع المباشر",
        "مكالمة تنسيق بضغطة واحدة",
      ],
    },
    coverage: {
      chapter: "التغطية",
      titleA: "الشرق الأوسط وشمال إفريقيا و",
      titleB: "تركيا.",
      para: "مسار متاح الآن في 14 دولة — من جبال الأطلس إلى البوسفور، ومن ساحل الخليج إلى وادي رم. أربع عشرة دولة، ومنصة واحدة للرحلات.",
      cap1: "مصر · الصحراء",
      cap2: "الخليج · الساحل",
      region: "المنطقة",
      regionValue: "الشرق الأوسط وشمال إفريقيا · تركيا · masar.ltd",
      bitCountries: "دولة",
      bitCities: "مدينة",
      bitSos: "استغاثة",
      tags: { hq: "المقر", new: "جديد", live: "متاح" },
      regions: REGION_NAMES.ar,
    },
    features: {
      chapter: "لماذا مسار",
      titleA: "لكل طريق حكاية.",
      titleB: "ونحن نحفظها.",
      lede: "سواء كنت تشق الممرات الجبلية وحدك أو تقود قافلة من مئة دراجة، مسار يمنحك الأدوات التي يريدها الدراجون فعلًا.",
      tag: "ميزة",
      cards: [
        {
          title: "قياسات دقيقة للرحلة",
          body: "المسار والمسافة والمدة والسرعة — تُسجَّل تلقائيًا. أعد تشغيل كل رحلة على خريطة تفصيلية وابنِ سجل قيادة شخصيًا يمكنك مشاركته.",
        },
        {
          title: "راليات وأيام الحلبة",
          body: "تصفح الراليات والرحلات الصحراوية والفعاليات المنظمة في جميع أنحاء المنطقة.",
        },
        {
          title: "تخطيط نقاط الطريق",
          body: "ارسم مسارك، وأسقط نقاط التفتيش، وادعُ شبكتك للانطلاق معك.",
        },
        {
          title: "كل ماركة، كل أسلوب",
          body: "كلاسيكية وباجرز ودراجات عضلية وسياحية ورياضية وكافيه ريسر — مسار مصمم لطريقة تنقل الدراجين في الشرق الأوسط وشمال إفريقيا وتركيا، من الكورنيش إلى الصحراء المفتوحة وكل ما بينهما.",
        },
        {
          title: "ملفات دراجين موثقة",
          body: "تابع الدراجين، وأضف أصدقاء من مختلف الماركات، واعرف من يقود بالقرب منك.",
        },
        {
          title: "خصوصية افتراضية",
          body: "رحلاتك وموقعك ملك لك. شارك فقط ما تختاره — ومع من تختاره.",
        },
      ],
    },
    faq: {
      chapter: "الأسئلة الشائعة",
      titleA: "أسئلة،",
      titleB: "وإجابات سريعة.",
      lede: "كل ما تحتاج معرفته قبل رحلتك الأولى مع مسار. هل ينقصك شيء؟ تواصل معنا على",
      items: [
        {
          q: "لمن صُمم مسار؟",
          a: "لدراجي الدراجات النارية في الشرق الأوسط وشمال إفريقيا وتركيا — من دراجي عطلات نهاية الأسبوع المنفردين إلى منظمي القوافل الكاملة. أي ماركة وأي أسلوب: كروزر أو رياضية أو مغامرات أو سياحية أو كافيه ريسر.",
        },
        {
          q: "ماذا يمكنني أن أفعل داخل تطبيق مسار؟",
          a: "خمسة أشياء: تتبّع رحلاتك بتسجيل GPS دقيق، وانضم إلى رحلات جماعية وفعاليات أو أنشئها، واكتشف متاجر دراجين موثوقة، ودردش مع مجتمعك، وفعّل استغاثة بضغطة واحدة تنبّه كل دراج قريب وتعرض أقرب المستشفيات.",
        },
        {
          q: "كيف تعمل ميزة الاستغاثة بالضبط؟",
          a: "ضغطة واحدة تفعّل استغاثة مسار. ينبّه التطبيق فورًا كل دراج قريب على المنصة مع موقعك الدقيق وتوجيه للوصول إليك، ويعرض أقرب المستشفيات ومراكز الطوارئ على خريطة مباشرة مرتبة حسب المسافة، ويشارك رابط موقع مباشر ليتمكن المستجيبون من الوصول إليك، ويتيح الاتصال بضغطة واحدة للتنسيق الفوري.",
        },
        {
          q: "هل يمكنني الانضمام إلى رحلة جماعية بدأت بالفعل؟",
          a: "نعم. يتيح لك مسار الانضمام إلى رحلة جماعية من أي نقطة تفتيش على الطريق — لا حاجة للتواجد عند نقطة الانطلاق. تصفح الرحلات القريبة منك أو في جميع أنحاء المنطقة وانضم أينما يناسبك.",
        },
        {
          q: "ما الدول والمدن المدعومة؟",
          a: "مسار متاح في 14 دولة: مصر والمغرب والجزائر وتونس وليبيا والأردن ولبنان وتركيا والسعودية والإمارات والكويت وقطر والبحرين وعُمان — أكثر من 60 مدينة. راجع قسم التغطية أعلاه لقائمة المدن الكاملة.",
        },
        {
          q: "هل المتاجر على مسار موثقة؟",
          a: "نعم. جميع متاجر الدراجين — المعدات ومراكز الصيانة وورش التعديل وموردي القطع — تُراجَع قبل إدراجها، مع التقييمات وأبرز المخزون واتجاهات بضغطة واحدة.",
        },
        {
          q: "كيف أدرج متجري على مسار؟",
          a: "أرسل لنا بريدًا إلكترونيًا على emailsupport@masar.ltd بعنوان «إدراج متجر» وسنشاركك عملية التحقق والمتطلبات.",
        },
        {
          q: "كيف أتواصل مع دعم مسار؟",
          a: "تواصل معنا في أي وقت على emailsupport@masar.ltd أو استخدم نموذج الاتصال أدناه. نرد خلال يوم عمل واحد.",
        },
      ],
    },
    support: {
      chapter: "الدعم",
      titleA: "تحدث مع",
      titleB: "إنسان.",
      lede: "دعم الدراجين أو إدراج المتاجر أو الشراكات أو الصحافة — راسلنا. نرد خلال يوم عمل واحد.",
      emailLabel: "البريد الإلكتروني",
      phoneLabel: "الهاتف (داخل التطبيق)",
      phoneValue: "اطلبه من تطبيق مسار",
      regionLabel: "المنطقة",
      regionValue: "الشرق الأوسط وشمال إفريقيا · تركيا · 14 دولة",
      domainLabel: "النطاق",
      nameLabel: "الاسم الكامل",
      emailFieldLabel: "البريد الإلكتروني",
      phoneFieldLabel: "الهاتف (اختياري)",
      subjectLabel: "الموضوع (اختياري)",
      messageLabel: "الرسالة",
      namePh: "اسمك الكامل",
      emailPh: "you@example.com",
      phonePh: "+20 100 000 0000",
      subjectPh: "كيف يمكننا مساعدتك؟",
      messagePh: "أخبرنا بما تحتاج…",
      consent: "بالإرسال، أنت توافق على التواصل معك عبر البريد الإلكتروني المقدم.",
      send: "أرسل الرسالة",
      sending: "جارٍ الإرسال…",
      success: "تم إرسال الرسالة. سنرد خلال يوم عمل واحد.",
      errRequired: "يرجى ملء الاسم والبريد الإلكتروني والرسالة.",
      errGeneric: "حدث خطأ ما. حاول مرة أخرى.",
    },
    privacySec: {
      chapter: "سياسة الخصوصية",
      titleA: "بياناتك،",
      titleB: "وشروطك.",
      open: "افتح الصفحة المستقلة",
      lastUpdated: "آخر تحديث: ديسمبر 2025",
    },
    footer: {
      blurb: "تطبيق الدراجات النارية للشرق الأوسط وشمال إفريقيا وتركيا. تتبّع الرحلات، وانضم إلى الرحلات الجماعية، واكتشف المتاجر، ودردش مع فريقك — واضغط زر الاستغاثة عندما يهم الأمر. 14 دولة متاحة.",
      navigate: "تنقّل",
      contact: "تواصل",
      serving: "نخدم الشرق الأوسط وشمال إفريقيا وتركيا",
      hours: "ساعات الدعم: 24/7",
      appstoreTag: "App Store · متاح",
      playTag: "Google Play · متاح",
      rights: "© {year} مسار · تطبيق دراجات نارية. جميع الحقوق محفوظة.",
      privacyLink: "الخصوصية",
      termsLink: "الشروط",
    },
    legal: {
      back: "العودة إلى الموقع",
      legal: "قانوني",
      lastUpdated: "آخر تحديث:",
      questions: "أسئلة؟ راسلنا على",
      home: "الرئيسية",
      privacyTitle: "سياسة الخصوصية",
      termsTitle: "شروط الخدمة",
      updated: "ديسمبر 2025",
    },
  },

  fr: {
    nav: {
      howItWorks: "Comment ça marche",
      services: "Services",
      coverage: "Couverture",
      faq: "FAQ",
      support: "Assistance",
      privacy: "Confidentialité",
      getApp: "Télécharger l’app",
      tag: "App Moto",
    },
    announce: {
      prefix: "Nouveau : ",
      text: "MASAR roule désormais en Afrique du Nord, Jordanie, Liban et Turquie — 14 pays en ligne.",
      dismiss: "Fermer l’annonce",
    },
    territory: {
      chapter: "Le Territoire",
      h1a: "Des dunes de l’Atlas",
      h1to: "à",
      h1b: "la Cappadoce,",
      h1c: "Pétra,",
      h1d: "jusqu’à la côte du Golfe.",
      h1e: "— en traversant l’Égypte.",
      para: "Quatorze pays. Soixante villes. Une seule app moto qui comprend comment roulent les motards de la région — les longues routes sahariennes, les cols d’Anatolie, les corniches du Levant et chaque rallye entre les deux.",
    },
    stores: {
      appstoreCaption: "Télécharger sur",
      playCaption: "Disponible sur",
    },
    marquee: {
      phrases: [
        "L’app moto pour la région MENA et la Turquie",
        "14 pays · 60+ villes",
        "Suivi. Sorties. Boutiques. Communauté. SOS.",
      ],
    },
    manifesto: {
      chapter: "Manifeste",
      titleA: "Trois étapes entre",
      titleB: "vous",
      titleC: "et la route.",
      steps: [
        {
          t: "Téléchargez et présentez-vous.",
          b: "Installez MASAR. Indiquez votre marque, votre discipline, votre région. Trente secondes.",
        },
        {
          t: "Roulez en solo. Ou avec votre équipe.",
          b: "Chaque kilomètre enregistré avec précision — ou rejoignez une sortie à n’importe quel point de contrôle.",
        },
        {
          t: "Trouvez votre place.",
          b: "Discutez, découvrez des boutiques vérifiées, et sachez qu’un simple SOS mobilise tous les motards autour de vous.",
        },
      ],
    },
    hero: {
      meta: "Depuis 2025 · Le Caire · Dubaï · Istanbul",
      h1a: "La route",
      h1b: "est à vous.",
      h1c: "MASAR roule",
      h1d: "avec vous.",
      para: "Une app moto pour les motards de la région MENA et de Turquie. Suivez chaque kilomètre, rejoignez des sorties, découvrez des boutiques vérifiées et déclenchez le SOS en un geste.",
      ctaPrimary: "Télécharger sur l’App Store",
      ctaSecondary: "Lire le manifeste",
      statsCountries: "Pays",
      statsCities: "Villes",
      statsSos: "SOS",
      liveChip: "En direct · Le Caire → Ain Sokhna",
      rideMeta: "Sortie 2417 · MSR",
      sosReady: "SOS prêt",
    },
    services: {
      chapter: "Fonctionnalités",
      titleA: "Cinq fonctions. Une app.",
      titleB: "Zéro changement.",
      lede: "MASAR est la seule plateforme pensée pour toute la vie du motard — communauté, navigation, commerce et sécurité.",
      items: [
        {
          title: "Suivez vos sorties",
          desc: "Enregistrez chaque kilomètre avec précision. Trace, distance, durée, vitesse — rejouez chaque sortie sur une carte détaillée.",
          tag: "01 · Trajets",
        },
        {
          title: "Sorties & événements",
          desc: "Découvrez des sorties organisées près de chez vous. Rejoignez-les depuis n’importe quel point du parcours. Créez les vôtres avec des étapes.",
          tag: "02 · Communauté",
        },
        {
          title: "Boutiques moto",
          desc: "Boutiques d’équipement vérifiées, centres d’entretien, garages de personnalisation — géolocalisés avec notes et itinéraires.",
          tag: "03 · Commerce",
        },
        {
          title: "Chat intégré",
          desc: "Ajoutez des amis, suivez des motards, élargissez votre réseau. Conversations de groupe, plans de sortie et discussions équipement — au même endroit.",
          tag: "04 · Connexion",
        },
        {
          title: "SOS · un geste",
          desc: "Alertez instantanément tous les motards proches avec votre position, affichez les hôpitaux les plus proches et partagez un lien en direct.",
          tag: "05 · Sécurité",
        },
      ],
      sosPills: [
        "Alerte instantanée des motards proches",
        "Carte en direct des hôpitaux proches",
        "Lien de position en direct",
        "Appel de coordination en un geste",
      ],
    },
    coverage: {
      chapter: "Couverture",
      titleA: "MENA et",
      titleB: "Turquie.",
      para: "MASAR est désormais disponible dans 14 pays — de l’Atlas au Bosphore, de la côte du Golfe à Wadi Rum. Quatorze pays, une seule plateforme.",
      cap1: "Égypte · Désert",
      cap2: "Golfe · Côte",
      region: "Région",
      regionValue: "MENA · Turquie · masar.ltd",
      bitCountries: "Pays",
      bitCities: "Villes",
      bitSos: "SOS",
      tags: { hq: "QG", new: "Nouveau", live: "En ligne" },
      regions: REGION_NAMES.fr,
    },
    features: {
      chapter: "Pourquoi MASAR",
      titleA: "Chaque route raconte",
      titleB: "une histoire. Nous la gardons.",
      lede: "Que vous attaquiez les cols en solo ou meniez un convoi de cent motos, MASAR vous donne les outils que les motards veulent vraiment.",
      tag: "Fonction",
      cards: [
        {
          title: "Télémétrie de précision",
          body: "Trace, distance, durée, vitesse — enregistrées automatiquement. Rejouez chaque sortie sur carte détaillée et constituez un historique à partager.",
        },
        {
          title: "Rallyes & track days",
          body: "Parcourez rallyes, raids désert et événements organisés dans toute la région.",
        },
        {
          title: "Planification d’étapes",
          body: "Tracez votre route, placez des points de contrôle et invitez votre réseau à rouler avec vous.",
        },
        {
          title: "Toutes marques, toutes disciplines",
          body: "Classiques, baggers, muscle bikes, routières, sportives et café racers — MASAR est pensé pour la façon de rouler en MENA et en Turquie, de la corniche au désert.",
        },
        {
          title: "Profils vérifiés",
          body: "Suivez des motards, ajoutez des amis de toutes marques et voyez qui roule près de vous.",
        },
        {
          title: "Privé par défaut",
          body: "Vos sorties et votre position restent à vous. Ne partagez que ce que vous choisissez, avec qui vous choisissez.",
        },
      ],
    },
    faq: {
      chapter: "FAQ",
      titleA: "Des questions,",
      titleB: "des réponses rapides.",
      lede: "Tout ce qu’il faut savoir avant votre première sortie avec MASAR. Une question manquante ? Écrivez à",
      items: [
        {
          q: "Pour qui MASAR est-il conçu ?",
          a: "Pour les motards de la région MENA et de Turquie — du baladeur du week-end à l’organisateur de convois. Toute marque, toute discipline : cruiser, sportive, adventure, routière ou café racer.",
        },
        {
          q: "Que puis-je faire dans l’app MASAR ?",
          a: "Cinq choses : suivre vos sorties avec un GPS précis, rejoindre ou créer des sorties et événements, découvrir des boutiques vérifiées, discuter avec votre communauté et déclencher un SOS en un geste qui alerte les motards proches et affiche les hôpitaux les plus proches.",
        },
        {
          q: "Comment fonctionne exactement le SOS ?",
          a: "Un geste active MASAR SOS. L’app alerte instantanément tous les motards proches avec votre position exacte et un guidage vers vous, affiche sur une carte en direct les hôpitaux et centres de traumatologie les plus proches classés par distance, partage un lien de position en direct et permet un appel de coordination en un geste.",
        },
        {
          q: "Puis-je rejoindre une sortie déjà commencée ?",
          a: "Oui. MASAR vous permet de rejoindre une sortie depuis n’importe quel point de contrôle du parcours — inutile d’être au départ. Parcourez les sorties près de chez vous ou dans toute la région et rejoignez-les où cela vous arrange.",
        },
        {
          q: "Quels pays et villes sont couverts ?",
          a: "MASAR est disponible dans 14 pays : Égypte, Maroc, Algérie, Tunisie, Libye, Jordanie, Liban, Turquie, Arabie Saoudite, Émirats, Koweït, Qatar, Bahreïn et Oman — plus de 60 villes. Voir la section Couverture pour la liste complète.",
        },
        {
          q: "Les boutiques MASAR sont-elles vérifiées ?",
          a: "Oui. Toutes les boutiques — équipement, centres d’entretien, garages de personnalisation et fournisseurs de pièces — sont vérifiées avant référencement, avec notes, points forts du stock et itinéraire en un geste.",
        },
        {
          q: "Comment référencer ma boutique sur MASAR ?",
          a: "Écrivez-nous à emailsupport@masar.ltd avec l’objet « Shop listing » et nous vous communiquerons le processus de vérification.",
        },
        {
          q: "Comment contacter l’assistance MASAR ?",
          a: "Écrivez-nous à tout moment à emailsupport@masar.ltd ou via le formulaire ci-dessous. Réponse sous un jour ouvré.",
        },
      ],
    },
    support: {
      chapter: "Assistance",
      titleA: "Parlez à un",
      titleB: "humain.",
      lede: "Assistance motards, référencement boutique, partenariats ou presse — écrivez-nous. Réponse sous un jour ouvré.",
      emailLabel: "Email",
      phoneLabel: "Téléphone (dans l’app)",
      phoneValue: "À demander dans l’app MASAR",
      regionLabel: "Région",
      regionValue: "MENA · Turquie · 14 pays",
      domainLabel: "Domaine",
      nameLabel: "Nom complet",
      emailFieldLabel: "Email",
      phoneFieldLabel: "Téléphone (optionnel)",
      subjectLabel: "Objet (optionnel)",
      messageLabel: "Message",
      namePh: "Votre nom complet",
      emailPh: "vous@exemple.com",
      phonePh: "+20 100 000 0000",
      subjectPh: "Comment pouvons-nous aider ?",
      messagePh: "Dites-nous ce qu’il vous faut…",
      consent: "En envoyant, vous acceptez d’être contacté à l’adresse fournie.",
      send: "Envoyer",
      sending: "Envoi…",
      success: "Message envoyé. Réponse sous un jour ouvré.",
      errRequired: "Veuillez renseigner nom, email et message.",
      errGeneric: "Une erreur est survenue. Réessayez.",
    },
    privacySec: {
      chapter: "Politique de confidentialité",
      titleA: "Vos données,",
      titleB: "vos règles.",
      open: "Ouvrir la page dédiée",
      lastUpdated: "Dernière mise à jour : décembre 2025",
    },
    footer: {
      blurb: "L’app moto pour la MENA et la Turquie. Suivez vos sorties, rejoignez des balades, découvrez des boutiques, discutez avec votre équipe — et déclenchez le SOS au moment crucial. 14 pays en ligne.",
      navigate: "Navigation",
      contact: "Contact",
      serving: "Au service de la MENA et de la Turquie",
      hours: "Assistance : 24/7",
      appstoreTag: "App Store · en ligne",
      playTag: "Google Play · en ligne",
      rights: "© {year} MASAR · App moto. Tous droits réservés.",
      privacyLink: "Confidentialité",
      termsLink: "Conditions",
    },
    legal: {
      back: "Retour au site",
      legal: "Mentions légales",
      lastUpdated: "Dernière mise à jour :",
      questions: "Des questions ? Écrivez-nous à",
      home: "Accueil",
      privacyTitle: "Politique de confidentialité",
      termsTitle: "Conditions d’utilisation",
      updated: "décembre 2025",
    },
  },

  tr: {
    nav: {
      howItWorks: "Nasıl çalışır",
      services: "Hizmetler",
      coverage: "Kapsam",
      faq: "SSS",
      support: "Destek",
      privacy: "Gizlilik",
      getApp: "Uygulamayı indir",
      tag: "Motosiklet Uygulaması",
    },
    announce: {
      prefix: "Yeni: ",
      text: "MASAR artık Kuzey Afrika, Ürdün, Lübnan ve Türkiye’de — 14 ülke yayında.",
      dismiss: "Duyuruyu kapat",
    },
    territory: {
      chapter: "Bölge",
      h1a: "Atlas kumullarından",
      h1to: "",
      h1b: "Kapadokya’ya,",
      h1c: "Petra’ya,",
      h1d: "ve Körfez kıyısına.",
      h1e: "— Mısır’dan geçerek.",
      para: "On dört ülke. Altmış şehir. Bölgedeki sürücülerin sürüş tarzını anlayan tek motosiklet uygulaması — uzun Sahra otoyolları, Anadolu geçitleri, Levant sahil yolları ve aradaki her ralli.",
    },
    stores: {
      appstoreCaption: "İndir:",
      playCaption: "Edinin:",
    },
    marquee: {
      phrases: [
        "MENA ve Türkiye için motosiklet uygulaması",
        "14 ülke · 60+ şehir",
        "Takip. Grup sürüşleri. Mağazalar. Topluluk. SOS.",
      ],
    },
    manifesto: {
      chapter: "Manifesto",
      titleA: "Sizinle",
      titleB: "açık yol",
      titleC: "arasında üç adım.",
      steps: [
        {
          t: "İndirin ve kendinizi tanıtın.",
          b: "MASAR’ı kurun. Motosiklet markanızı, sürüş tarzınızı ve bölgenizi ayarlayın. Otuz saniye.",
        },
        {
          t: "Tek başınıza takip edin. Ya da ekiple sürün.",
          b: "Her kilometre hassasiyetle kaydedilir — ya da herhangi bir kontrol noktasından grup sürüşüne katılın.",
        },
        {
          t: "Bir yere ait olun.",
          b: "Sohbet edin, onaylı mağazaları keşfedin ve tek bir SOS dokunuşunun çevrenizdeki her sürücüyü yanınıza getirdiğini bilin.",
        },
      ],
    },
    hero: {
      meta: "Kuruluş 2025 · Kahire · Dubai · İstanbul",
      h1a: "Yol",
      h1b: "sizin.",
      h1c: "MASAR sizinle",
      h1d: "birlikte sürer.",
      para: "MENA ve Türkiye’deki sürücüler için motosiklet uygulaması. Her kilometreyi takip edin, grup sürüşlerine katılın, onaylı mağazaları keşfedin ve SOS’e tek dokunuşla ulaşın.",
      ctaPrimary: "App Store’dan indirin",
      ctaSecondary: "Manifestoyu okuyun",
      statsCountries: "Ülke",
      statsCities: "Şehir",
      statsSos: "SOS",
      liveChip: "Canlı · Kahire → Ayn Suhne",
      rideMeta: "Sürüş 2417 · MSR",
      sosReady: "SOS hazır",
    },
    services: {
      chapter: "Özellikler",
      titleA: "Beş özellik. Tek uygulama.",
      titleB: "Sıfır geçiş.",
      lede: "MASAR, sürüş hayatının tamamı etrafında kurulmuş tek platformdur — topluluk, navigasyon, ticaret ve güvenlik.",
      items: [
        {
          title: "Sürüşlerinizi takip edin",
          desc: "Her kilometreyi hassasiyetle kaydedin. Rota, mesafe, süre, hız — her sürüşü ayrıntılı haritada yeniden oynatın.",
          tag: "01 · Sürüşler",
        },
        {
          title: "Grup sürüşleri ve etkinlikler",
          desc: "Yakınınızdaki organize sürüşleri keşfedin. Rota üzerindeki herhangi bir noktadan katılın. Ara noktalarla kendi sürüşünüzü oluşturun.",
          tag: "02 · Topluluk",
        },
        {
          title: "Sürücü mağazaları",
          desc: "Onaylı ekipman mağazaları, servis merkezleri, özelleştirme garajları — konumunuza göre puanlar ve yol tarifleriyle.",
          tag: "03 · Ticaret",
        },
        {
          title: "Uygulama içi sohbet",
          desc: "Arkadaş ekleyin, sürücüleri takip edin, ağınızı büyütün. Grup sohbetleri, sürüş planları ve ekipman sohbetleri — hepsi tek yerde.",
          tag: "04 · Bağlantı",
        },
        {
          title: "SOS · tek dokunuş",
          desc: "Konumunuzla çevredeki her sürücüyü anında uyarın, en yakın hastaneleri gösterin ve yardım için canlı konum bağlantısı paylaşın.",
          tag: "05 · Güvenlik",
        },
      ],
      sosPills: [
        "Yakındaki sürücülere anında uyarı",
        "En yakın hastanelerin canlı haritası",
        "Canlı konum paylaşım bağlantısı",
        "Tek dokunuşla koordinasyon araması",
      ],
    },
    coverage: {
      chapter: "Kapsam",
      titleA: "MENA ve",
      titleB: "Türkiye.",
      para: "MASAR artık 14 ülkede yayında — Atlas Dağları’ndan Boğaz’a, Körfez kıyısından Wadi Rum’a. On dört ülke, tek sürüş merkezi.",
      cap1: "Mısır · Çöl",
      cap2: "Körfez · Sahil",
      region: "Bölge",
      regionValue: "MENA · Türkiye · masar.ltd",
      bitCountries: "Ülke",
      bitCities: "Şehir",
      bitSos: "SOS",
      tags: { hq: "Merkez", new: "Yeni", live: "Yayında" },
      regions: REGION_NAMES.tr,
    },
    features: {
      chapter: "Neden MASAR",
      titleA: "Her yol bir hikâye anlatır.",
      titleB: "Biz onu saklarız.",
      lede: "İster tek başınıza dağ geçitlerinde sürün, ister yüz motosikletlik bir konvoya liderlik edin — MASAR size sürücülerin gerçekten istediği araçları sunar.",
      tag: "Özellik",
      cards: [
        {
          title: "Hassas sürüş telemetrisi",
          body: "Rota, mesafe, süre, hız — otomatik kaydedilir. Her sürüşü ayrıntılı haritada yeniden oynatın ve paylaşabileceğiniz kişisel bir sürüş geçmişi oluşturun.",
        },
        {
          title: "Ralliler ve pist günleri",
          body: "Bölge genelindeki rallileri, çöl sürüşlerini ve organize etkinlikleri keşfedin.",
        },
        {
          title: "Ara nokta planlaması",
          body: "Rotanızı çizin, kontrol noktaları bırakın ve ağınızı sizinle sürmeye davet edin.",
        },
        {
          title: "Her marka, her disiplin",
          body: "Klasikler, bagger’lar, muscle bike’lar, tourer’lar, sport ve café racer’lar — MASAR, sahil yolundan açık çöle kadar MENA ve Türkiye’deki sürüş tarzına göre ayarlandı.",
        },
        {
          title: "Doğrulanmış sürücü profilleri",
          body: "Sürücüleri takip edin, farklı markalardan arkadaşlar ekleyin ve yakınınızda kimin sürdüğünü görün.",
        },
        {
          title: "Varsayılan olarak gizli",
          body: "Sürüşleriniz ve konumunuz size aittir. Yalnızca istediğinizi, istediğiniz kişiyle paylaşın.",
        },
      ],
    },
    faq: {
      chapter: "SSS",
      titleA: "Sorular,",
      titleB: "hızlı yanıtlar.",
      lede: "MASAR ile ilk sürüşünüzden önce bilmeniz gereken her şey. Bir şey mi eksik? Bize yazın:",
      items: [
        {
          q: "MASAR kimler için tasarlandı?",
          a: "MENA ve Türkiye’deki motosiklet sürücüleri için — yalnız hafta sonu sürücülerinden konvoy organizatörlerine. Her marka, her disiplin: cruiser, sport, adventure, tourer veya café racer.",
        },
        {
          q: "MASAR uygulamasında neler yapabilirim?",
          a: "Beş şey: hassas GPS kaydıyla sürüşlerinizi takip edin, grup sürüşlerine ve etkinliklere katılın veya oluşturun, onaylı sürücü mağazalarını keşfedin, topluluğunuzla sohbet edin ve yakındaki her sürücüyü uyarıp en yakın hastaneleri gösteren tek dokunuşluk SOS’i tetikleyin.",
        },
        {
          q: "SOS özelliği tam olarak nasıl çalışır?",
          a: "Tek dokunuş MASAR SOS’i etkinleştirir. Uygulama, platformdaki yakın tüm sürücüleri tam konumunuz ve size ulaşma yönlendirmesiyle anında uyarır, en yakın hastaneleri ve travma merkezlerini mesafeye göre sıralanmış canlı haritada gösterir, müdahale ekiplerinin size ulaşabilmesi için canlı konum bağlantısı paylaşır ve gerçek zamanlı koordinasyon için tek dokunuşla arama sağlar.",
        },
        {
          q: "Başlamış bir grup sürüşüne katılabilir miyim?",
          a: "Evet. MASAR, rota üzerindeki herhangi bir kontrol noktasından grup sürüşüne katılmanızı sağlar — başlangıçta olmanıza gerek yok. Yakınınızdaki veya bölge genelindeki sürüşlere göz atın ve size uygun yerden katılın.",
        },
        {
          q: "Hangi ülkeler ve şehirler destekleniyor?",
          a: "MASAR 14 ülkede yayında: Mısır, Fas, Cezayir, Tunus, Libya, Ürdün, Lübnan, Türkiye, Suudi Arabistan, BAE, Kuveyt, Katar, Bahreyn ve Umman — 60’tan fazla şehir. Tam şehir listesi için yukarıdaki Kapsam bölümüne bakın.",
        },
        {
          q: "MASAR’daki mağazalar doğrulanıyor mu?",
          a: "Evet. Tüm sürücü mağazaları — ekipman, servis merkezleri, özelleştirme garajları ve parça tedarikçileri — listelenmeden önce incelenir; puanlar, stok öne çıkanları ve tek dokunuşla yol tarifi içerir.",
        },
        {
          q: "Mağazamı MASAR’a nasıl eklerim?",
          a: "«Mağaza kaydı» konu başlığıyla emailsupport@masar.ltd adresine e-posta gönderin; doğrulama sürecini ve gereksinimleri paylaşalım.",
        },
        {
          q: "MASAR desteğiyle nasıl iletişim kurarım?",
          a: "emailsupport@masar.ltd adresinden veya aşağıdaki formdan bize istediğiniz zaman ulaşın. Bir iş günü içinde yanıt veriyoruz.",
        },
      ],
    },
    support: {
      chapter: "Destek",
      titleA: "Bir",
      titleB: "insanla konuşun.",
      lede: "Sürücü desteği, mağaza kayıtları, ortaklıklar veya basın — bize yazın. Bir iş günü içinde yanıt veriyoruz.",
      emailLabel: "E-posta",
      phoneLabel: "Telefon (uygulamada)",
      phoneValue: "MASAR uygulamasından isteyin",
      regionLabel: "Bölge",
      regionValue: "MENA · Türkiye · 14 ülke",
      domainLabel: "Alan adı",
      nameLabel: "Ad soyad",
      emailFieldLabel: "E-posta",
      phoneFieldLabel: "Telefon (isteğe bağlı)",
      subjectLabel: "Konu (isteğe bağlı)",
      messageLabel: "Mesaj",
      namePh: "Adınız soyadınız",
      emailPh: "siz@ornek.com",
      phonePh: "+20 100 000 0000",
      subjectPh: "Size nasıl yardımcı olabiliriz?",
      messagePh: "İhtiyacınızı anlatın…",
      consent: "Göndererek, verdiğiniz e-posta adresinden sizinle iletişime geçilmesini kabul edersiniz.",
      send: "Mesajı gönder",
      sending: "Gönderiliyor…",
      success: "Mesaj gönderildi. Bir iş günü içinde yanıt vereceğiz.",
      errRequired: "Lütfen ad, e-posta ve mesaj alanlarını doldurun.",
      errGeneric: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    },
    privacySec: {
      chapter: "Gizlilik Politikası",
      titleA: "Verileriniz,",
      titleB: "kurallarınız.",
      open: "Ayrı sayfayı aç",
      lastUpdated: "Son güncelleme: Aralık 2025",
    },
    footer: {
      blurb: "MENA ve Türkiye için motosiklet uygulaması. Sürüşleri takip edin, grup sürüşlerine katılın, mağazaları keşfedin, ekibinizle sohbet edin — ve en kritik anda SOS’e basın. 14 ülke yayında.",
      navigate: "Gezinme",
      contact: "İletişim",
      serving: "MENA ve Türkiye’ye hizmet",
      hours: "Destek: 7/24",
      appstoreTag: "App Store · yayında",
      playTag: "Google Play · yayında",
      rights: "© {year} MASAR · Motosiklet Uygulaması. Tüm hakları saklıdır.",
      privacyLink: "Gizlilik",
      termsLink: "Şartlar",
    },
    legal: {
      back: "Siteye dön",
      legal: "Yasal",
      lastUpdated: "Son güncelleme:",
      questions: "Sorularınız mı var? Bize yazın:",
      home: "Ana sayfa",
      privacyTitle: "Gizlilik Politikası",
      termsTitle: "Hizmet Şartları",
      updated: "Aralık 2025",
    },
  },
};
